export default __webpack_public_path__ + "images/a26ad648a5b32e3103315f8b0fef36a0.png";